// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/user/v1/user.proto" (package "c1.api.user.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ProfileType } from "../../profiletype/v1/profiletype";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.user.v1.GetEmploymentStatusSearchTermsRequest
 */
export interface GetEmploymentStatusSearchTermsRequest {
}
/**
 * @generated from protobuf message c1.api.user.v1.GetEmploymentStatusSearchTermsResponse
 */
export interface GetEmploymentStatusSearchTermsResponse {
    /**
     * @generated from protobuf field: repeated string terms = 1
     */
    terms: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.GetJobTitleSearchTermsRequest
 */
export interface GetJobTitleSearchTermsRequest {
}
/**
 * @generated from protobuf message c1.api.user.v1.GetJobTitleSearchTermsResponse
 */
export interface GetJobTitleSearchTermsResponse {
    /**
     * @generated from protobuf field: repeated string terms = 1
     */
    terms: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.GetDepartmentSearchTermsRequest
 */
export interface GetDepartmentSearchTermsRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetDepartmentSearchTermsResponse
 */
export interface GetDepartmentSearchTermsResponse {
    /**
     * @generated from protobuf field: repeated string terms = 1
     */
    terms: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.CountAppUsersWithoutManagerRequest
 */
export interface CountAppUsersWithoutManagerRequest {
}
/**
 * @generated from protobuf message c1.api.user.v1.CountAppUsersWithoutManagerResponse
 */
export interface CountAppUsersWithoutManagerResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.user.v1.UsersWithoutManagerRequest
 */
export interface UsersWithoutManagerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UsersWithoutManagerResponse
 */
export interface UsersWithoutManagerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1
     */
    list: UserView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest
 */
export interface UsersWithUnspecifiedEmploymentStatusRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusResponse
 */
export interface UsersWithUnspecifiedEmploymentStatusResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1
     */
    list: UserView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * The user expand mask is used to indicate which related objects should be expanded in the response.
 * The supported paths are 'role_ids', 'manager_ids', 'delegated_user_id', 'directory_ids', and '*'.
 *
 * @generated from protobuf message c1.api.user.v1.UserExpandMask
 */
export interface UserExpandMask {
    /**
     * An array of paths to be expanded in the response.
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * The UserView object provides a user response object, as well as JSONPATHs to related objects provided by expanders.
 *
 * @generated from protobuf message c1.api.user.v1.UserView
 */
export interface UserView {
    /**
     * The user object being returned by the request.
     *
     * @generated from protobuf field: c1.api.user.v1.User user = 1
     */
    user?: User;
    /**
     * JSONPATH expression indicating the location of the roles of the current user in the expanded array.
     *
     * @generated from protobuf field: string roles_path = 2
     */
    rolesPath: string;
    /**
     * JSONPATH expression indicating the location of the user objects that managed the current user in the expanded array.
     *
     * @generated from protobuf field: string managers_path = 3
     */
    managersPath: string;
    /**
     * JSONPATH expression indicating the location of the user objects of delegates of the current user in the expanded array.
     *
     * @generated from protobuf field: string delegated_user_path = 4
     */
    delegatedUserPath: string;
    /**
     * JSONPATH expression indicating the location of directory objects in the expanded array.
     *
     * @generated from protobuf field: string directories_path = 5
     */
    directoriesPath: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingSource
 */
export interface UserAttributeMappingSource {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1
     */
    userAttributeMappingId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 4
     */
    appUserProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string value = 5
     */
    value: string;
}
/**
 * A reference to a user.
 *
 * @generated from protobuf message c1.api.user.v1.UserRef
 */
export interface UserRef {
    /**
     * The id of the user.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * The User object provides all of the details for an user, as well as some configuration.
 *
 * @generated from protobuf message c1.api.user.v1.User
 */
export interface User {
    /**
     * A unique identifier of the user.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The display name of the user.
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * This is the user's email.
     *
     * @generated from protobuf field: string email = 3
     */
    email: string;
    /**
     * This is a list of all of the user's emails from app users.
     *
     * @generated from protobuf field: repeated string emails = 24
     */
    emails: string[];
    /**
     * A list of source data for the email attribute.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource email_sources = 30
     */
    emailSources: UserAttributeMappingSource[];
    /**
     * This is the user's primary username. Typically sourced from the primary directory.
     *
     * @generated from protobuf field: string username = 25
     */
    username: string;
    /**
     * This is a list of all of the user's usernames from app users.
     *
     * @generated from protobuf field: repeated string usernames = 26
     */
    usernames: string[];
    /**
     * A list of source data for the usernames attribute.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource username_sources = 27
     */
    usernameSources: UserAttributeMappingSource[];
    /**
     * This is a list of all of the user's employee IDs from app users.
     *
     * @generated from protobuf field: repeated string employee_ids = 28
     */
    employeeIds: string[];
    /**
     * A list of source data for the employee IDs attribute.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource employee_id_sources = 29
     */
    employeeIdSources: UserAttributeMappingSource[];
    /**
     * The status of the user in the system.
     *
     * @generated from protobuf field: c1.api.user.v1.UserStatus status = 4
     */
    status: UserStatus;
    /**
     * A list of unique identifiers that maps to ConductorOne's user roles let you assign users permissions tailored to the work they do in the software.
     *
     * @generated from protobuf field: repeated string role_ids = 5
     */
    roleIds: string[];
    /**
     * A list of ids of the user's managers.
     *
     * @generated from protobuf field: repeated string manager_ids = 6
     */
    managerIds: string[];
    /**
     * A list of objects mapped based on managerId attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource manager_sources = 11
     */
    managerSources: UserAttributeMappingSource[];
    /**
     * The datetime, in RFC3339 format, of when the User was created in Conductor One.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the User was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the User was deleted in Conductor One.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 9
     */
    deletedAt?: Timestamp;
    /**
     * The id of the user to whom tasks will be automatically reassigned to.
     *
     * @generated from protobuf field: string delegated_user_id = 10
     */
    delegatedUserId: string;
    /**
     * The status of the user in the directory.
     *
     * @generated from protobuf field: c1.api.user.v1.UserStatus directory_status = 12
     */
    directoryStatus: UserStatus;
    /**
     * A list of objects mapped based on directoryStatus attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource directory_status_sources = 13
     */
    directoryStatusSources: UserAttributeMappingSource[];
    /**
     * The job title of the user.
     *
     * @generated from protobuf field: string job_title = 14
     */
    jobTitle: string;
    /**
     * A list of objects mapped based on jobTitle attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource job_title_sources = 15
     */
    jobTitleSources: UserAttributeMappingSource[];
    /**
     * The department which the user belongs to in the organization.
     *
     * @generated from protobuf field: string department = 16
     */
    department: string;
    /**
     * A list of objects mapped based on department attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource department_sources = 17
     */
    departmentSources: UserAttributeMappingSource[];
    /**
     * The users employment status.
     *
     * @generated from protobuf field: string employment_status = 18
     */
    employmentStatus: string;
    /**
     * A list of objects mapped based on employmentStatus attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource employment_status_sources = 19
     */
    employmentStatusSources: UserAttributeMappingSource[];
    /**
     * The employment type of the user.
     *
     * @generated from protobuf field: string employment_type = 20
     */
    employmentType: string;
    /**
     * A list of objects mapped based on employmentType attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource employment_type_sources = 21
     */
    employmentTypeSources: UserAttributeMappingSource[];
    /**
     * A list of unique ids that represent different directories.
     *
     * @generated from protobuf field: repeated string directory_ids = 22
     */
    directoryIds: string[];
    /**
     * TODO: Eventually this should be removed in favor of attributes. Analysis should use attributes
     *
     * @generated from protobuf field: google.protobuf.Struct profile = 23
     */
    profile?: Struct;
    /**
     * The type of the user.
     *
     * @generated from protobuf field: c1.api.user.v1.UserType type = 31
     */
    type: UserType;
    /**
     * The origin of the user, describing who owns the user's lifecycle.
     *
     * @generated from protobuf field: c1.api.user.v1.UserOrigin origin = 32
     */
    origin: UserOrigin;
}
/**
 * @generated from protobuf message c1.api.user.v1.ExpiringUserDelegationBinding
 */
export interface ExpiringUserDelegationBinding {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: string delegated_user_id = 2
     */
    delegatedUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_at = 3
     */
    startAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expiration_at = 4
     */
    expirationAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.user.v1.IntrospectRequest
 */
export interface IntrospectRequest {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 1
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.IntrospectResponse
 */
export interface IntrospectResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserView user_view = 1
     */
    userView?: UserView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserServiceGetRequest
 */
export interface UserServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 2
     */
    expandMask?: UserExpandMask;
}
/**
 * The UserServiceGetResponse returns a user view which has a user including JSONPATHs to the expanded items in the expanded array.
 *
 * @generated from protobuf message c1.api.user.v1.UserServiceGetResponse
 */
export interface UserServiceGetResponse {
    /**
     * A view of the user, contains the serialized user and paths to objects referenced by the user.
     *
     * @generated from protobuf field: c1.api.user.v1.UserView user_view = 1
     */
    userView?: UserView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserServiceGetUsersByIDsRequest
 */
export interface UserServiceGetUsersByIDsRequest {
    /**
     * @generated from protobuf field: repeated string ids = 1
     */
    ids: string[];
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 2
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserServiceGetUsersByIDsResponse
 */
export interface UserServiceGetUsersByIDsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView items = 1
     */
    items: UserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserServiceListRequest
 */
export interface UserServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3
     */
    expandMask?: UserExpandMask;
}
/**
 * The UserServiceListResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.user.v1.UserServiceListResponse
 */
export interface UserServiceListResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1
     */
    list: UserView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * Search for users based on some filters.
 *
 * @generated from protobuf message c1.api.user.v1.SearchUsersRequest
 */
export interface SearchUsersRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and emails.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * The expand mask defines the list of paths to be expanded in the return value.
     *
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 6
     */
    expandMask?: UserExpandMask;
    /**
     * Search for users that have any of the statuses on this list. This can only be ENABLED, DISABLED, and DELETED
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_statuses = 7
     */
    userStatuses: UserStatus[];
    /**
     * Search for users that have any of the role IDs on this list.
     *
     * @generated from protobuf field: repeated string role_ids = 8
     */
    roleIds: string[];
    /**
     * An array of users IDs to exclude from the results.
     *
     * @generated from protobuf field: repeated string exclude_ids = 9
     */
    excludeIds: string[];
    /**
     * Deprecated. Use refs array instead.
     *
     * @generated from protobuf field: repeated string ids = 10
     */
    ids: string[];
    /**
     * An array of user refs to restrict the return values to by ID.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef refs = 11
     */
    refs: UserRef[];
    /**
     * Search for users based on their email (exact match).
     *
     * @generated from protobuf field: string email = 12
     */
    email: string;
    /**
     * An array of types to exclude from the results.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserType exclude_types = 13
     */
    excludeTypes: UserType[];
    /**
     * Search for users that have any of the manager IDs on this list.
     *
     * @generated from protobuf field: repeated string manager_ids = 14
     */
    managerIds: string[];
    /**
     * Search for users that have any of the job titles on this list.
     *
     * @generated from protobuf field: repeated string job_titles = 15
     */
    jobTitles: string[];
    /**
     * Search for users that have any of the departments on this list.
     *
     * @generated from protobuf field: repeated string departments = 16
     */
    departments: string[];
    /**
     * Filter to include only users with these origins.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserOrigin origins = 17
     */
    origins: UserOrigin[];
    /**
     * Filter to exclude users with these origins.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserOrigin exclude_origins = 18
     */
    excludeOrigins: UserOrigin[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUsersResponse
 */
export interface SearchUsersResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1
     */
    list: UserView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchManagedUsersRequest
 */
export interface SearchManagedUsersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string manager_id = 3
     */
    managerId: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_user_ids = 5
     */
    excludeUserIds: string[];
    /**
     * @generated from protobuf field: repeated string user_ids = 6
     */
    userIds: string[];
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 7
     */
    expandMask?: UserExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_statuses = 8
     */
    userStatuses: UserStatus[];
    /**
     * @generated from protobuf field: repeated string role_ids = 9
     */
    roleIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchManagedUsersResponse
 */
export interface SearchManagedUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1
     */
    list: UserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchManagedUsersForAccessRequestsRequest
 */
export interface SearchManagedUsersForAccessRequestsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string manager_id = 3
     */
    managerId: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_user_ids = 5
     */
    excludeUserIds: string[];
    /**
     * @generated from protobuf field: repeated string user_ids = 6
     */
    userIds: string[];
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 7
     */
    expandMask?: UserExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_statuses = 8
     */
    userStatuses: UserStatus[];
    /**
     * @generated from protobuf field: repeated string role_ids = 9
     */
    roleIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchManagedUsersForAccessRequestsResponse
 */
export interface SearchManagedUsersForAccessRequestsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1
     */
    list: UserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1
     */
    user?: User;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetDelegatedUserRequest
 */
export interface SetDelegatedUserRequest {
    /**
     * @generated from protobuf field: string delegated_user_id = 1
     */
    delegatedUserId: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 2
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetUserRolesRequest
 */
export interface SetUserRolesRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: repeated string role_ids = 2
     */
    roleIds: string[];
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUsersWithCELRequest
 */
export interface SearchUsersWithCELRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and emails.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * The expand mask defines the list of paths to be expanded in the return value.
     *
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 4
     */
    expandMask?: UserExpandMask;
    /**
     * Search for users based on their email (exact match).
     *
     * @generated from protobuf field: string email = 5
     */
    email: string;
    /**
     * The CEL expression to filter the users.
     *
     * @generated from protobuf field: string expression = 6
     */
    expression: string;
    /**
     * @generated from protobuf field: repeated string exclude_user_ids = 7
     */
    excludeUserIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUsersWithCELResponse
 */
export interface SearchUsersWithCELResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1
     */
    list: UserView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * Request for streaming CEL-based user search.
 *
 * @generated from protobuf message c1.api.user.v1.StreamSearchUsersWithCELRequest
 */
export interface StreamSearchUsersWithCELRequest {
    /**
     * The CEL expression to filter the users.
     *
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
    /**
     * User IDs to exclude from the results.
     *
     * @generated from protobuf field: repeated string exclude_user_ids = 2
     */
    excludeUserIds: string[];
}
/**
 * Streaming response for CEL-based user search.
 *
 * @generated from protobuf message c1.api.user.v1.StreamSearchUsersWithCELResponse
 */
export interface StreamSearchUsersWithCELResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "matched";
        /**
         * Batch of users that matched the CEL expression.
         *
         * @generated from protobuf field: c1.api.user.v1.StreamSearchUsersWithCELResponse.Matched matched = 1
         */
        matched: StreamSearchUsersWithCELResponse_Matched;
    } | {
        oneofKind: "status";
        /**
         * Progress status update.
         *
         * @generated from protobuf field: c1.api.user.v1.StreamSearchUsersWithCELResponse.Status status = 2
         */
        status: StreamSearchUsersWithCELResponse_Status;
    } | {
        oneofKind: "failed";
        /**
         * A user that failed CEL evaluation with an error message.
         *
         * @generated from protobuf field: c1.api.user.v1.StreamSearchUsersWithCELResponse.Failed failed = 3
         */
        failed: StreamSearchUsersWithCELResponse_Failed;
    } | {
        oneofKind: "stopped";
        /**
         * Indicates the stream has completed.
         *
         * @generated from protobuf field: bool stopped = 4
         */
        stopped: boolean;
    } | {
        oneofKind: undefined;
    };
}
/**
 * A batch of matched users.
 *
 * @generated from protobuf message c1.api.user.v1.StreamSearchUsersWithCELResponse.Matched
 */
export interface StreamSearchUsersWithCELResponse_Matched {
    /**
     * The list of users that matched the CEL expression in this batch.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
}
/**
 * Progress status update.
 *
 * @generated from protobuf message c1.api.user.v1.StreamSearchUsersWithCELResponse.Status
 */
export interface StreamSearchUsersWithCELResponse_Status {
    /**
     * Total number of users to scan.
     *
     * @generated from protobuf field: int64 total = 1
     */
    total: number;
    /**
     * Number of users scanned so far.
     *
     * @generated from protobuf field: int64 scanned = 2
     */
    scanned: number;
    /**
     * Number of users that matched the CEL expression.
     *
     * @generated from protobuf field: int64 matched = 3
     */
    matched: number;
    /**
     * Number of users that failed CEL evaluation.
     *
     * @generated from protobuf field: int64 errors = 4
     */
    errors: number;
}
/**
 * A user that failed CEL evaluation.
 *
 * @generated from protobuf message c1.api.user.v1.StreamSearchUsersWithCELResponse.Failed
 */
export interface StreamSearchUsersWithCELResponse_Failed {
    /**
     * The user record that failed CEL evaluation.
     *
     * @generated from protobuf field: c1.api.user.v1.User user = 1
     */
    user?: User;
    /**
     * The error message describing why CEL evaluation failed.
     *
     * @generated from protobuf field: string error = 2
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeWithProfileTypeSource
 */
export interface UserAttributeWithProfileTypeSource {
    /**
     * @generated from protobuf field: string profile_attribute_key = 1
     */
    profileAttributeKey: string;
    /**
     * @generated from protobuf field: string profile_attribute_value = 2
     */
    profileAttributeValue: string;
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileType profile_types = 3
     */
    profileTypes: ProfileType[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceRequest
 */
export interface SearchUserAttributesWithProfileTypeSourceRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceResponse
 */
export interface SearchUserAttributesWithProfileTypeSourceResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeWithProfileTypeSource list = 1
     */
    list: UserAttributeWithProfileTypeSource[];
}
/**
 * @generated from protobuf message c1.api.user.v1.AgentView
 */
export interface AgentView {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1
     */
    user?: User;
    /**
     * @generated from protobuf field: string instructions = 2
     */
    instructions: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentInstructionsType agent_instructions_type = 4
     */
    agentInstructionsType: AgentInstructionsType;
}
/**
 * @generated from protobuf message c1.api.user.v1.CreateAgentRequest
 */
export interface CreateAgentRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.CreateAgentResponse
 */
export interface CreateAgentResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentView agent_view = 1
     */
    agentView?: AgentView;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetAgentRequest
 */
export interface GetAgentRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetAgentResponse
 */
export interface GetAgentResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentView agent_view = 1
     */
    agentView?: AgentView;
}
/**
 * @generated from protobuf message c1.api.user.v1.ListAgentsRequest
 */
export interface ListAgentsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.ListAgentsResponse
 */
export interface ListAgentsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.AgentView list = 1
     */
    list: AgentView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetAgentInstructionsRequest
 */
export interface SetAgentInstructionsRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string instructions = 2
     */
    instructions: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentInstructionsType agent_instructions_type = 3
     */
    agentInstructionsType: AgentInstructionsType;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetAgentInstructionsResponse
 */
export interface SetAgentInstructionsResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentView agent_view = 1
     */
    agentView?: AgentView;
}
/**
 * @generated from protobuf message c1.api.user.v1.DeleteAgentRequest
 */
export interface DeleteAgentRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.DeleteAgentResponse
 */
export interface DeleteAgentResponse {
}
/**
 * @generated from protobuf message c1.api.user.v1.AgentRef
 */
export interface AgentRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchAgentsRequest
 */
export interface SearchAgentsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.AgentRef refs = 3
     */
    refs: AgentRef[];
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchAgentsResponse
 */
export interface SearchAgentsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.AgentView list = 1
     */
    list: AgentView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetExpiringUserDelegationBindingRequest
 */
export interface GetExpiringUserDelegationBindingRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetExpiringUserDelegationBindingResponse
 */
export interface GetExpiringUserDelegationBindingResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.ExpiringUserDelegationBinding item = 1
     */
    item?: ExpiringUserDelegationBinding;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingByAdminRequest
 */
export interface SetExpiringUserDelegationBindingByAdminRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: string delegated_user_id = 2
     */
    delegatedUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delegation_start_at = 3
     */
    delegationStartAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delegation_expire_at = 4
     */
    delegationExpireAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingByAdminResponse
 */
export interface SetExpiringUserDelegationBindingByAdminResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.ExpiringUserDelegationBinding item = 1
     */
    item?: ExpiringUserDelegationBinding;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingSelfRequest
 */
export interface SetExpiringUserDelegationBindingSelfRequest {
    /**
     * @generated from protobuf field: string delegated_user_id = 1
     */
    delegatedUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delegation_start_at = 2
     */
    delegationStartAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delegation_expire_at = 3
     */
    delegationExpireAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingSelfResponse
 */
export interface SetExpiringUserDelegationBindingSelfResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.ExpiringUserDelegationBinding item = 1
     */
    item?: ExpiringUserDelegationBinding;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetUserProfileTypesRequest
 */
export interface GetUserProfileTypesRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetUserProfileTypesResponse
 */
export interface GetUserProfileTypesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileType profile_types = 1
     */
    profileTypes: ProfileType[];
}
/**
 * @generated from protobuf message c1.api.user.v1.PreviewUserProfileWithProfileTypesRequest
 */
export interface PreviewUserProfileWithProfileTypesRequest {
    /**
     * The user to preview profile changes for
     *
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * ProfileType IDs to add to the user's current set
     *
     * @generated from protobuf field: repeated string profile_type_ids_to_add = 2
     */
    profileTypeIdsToAdd: string[];
    /**
     * ProfileType IDs to remove from the user's current set
     *
     * @generated from protobuf field: repeated string profile_type_ids_to_remove = 3
     */
    profileTypeIdsToRemove: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.PreviewUserProfileWithProfileTypesResponse
 */
export interface PreviewUserProfileWithProfileTypesResponse {
    /**
     * The user's current profile with their actual ProfileType assignments
     *
     * @generated from protobuf field: google.protobuf.Struct current_profile = 1
     */
    currentProfile?: Struct;
    /**
     * The projected profile if the user had the specified ProfileTypes
     *
     * @generated from protobuf field: google.protobuf.Struct projected_profile = 2
     */
    projectedProfile?: Struct;
    /**
     * Automation rules, access reviews, and other entities that reference the changing profile fields
     *
     * @generated from protobuf field: repeated c1.api.user.v1.AffectedReference potentially_affected_references = 3
     */
    potentiallyAffectedReferences: AffectedReference[];
}
/**
 * @generated from protobuf message c1.api.user.v1.AffectedReference
 */
export interface AffectedReference {
    /**
     * The type of entity
     *
     * @generated from protobuf field: c1.api.user.v1.AffectedReferenceEntityType entity_type = 1
     */
    entityType: AffectedReferenceEntityType;
    /**
     * The ID of the entity
     *
     * @generated from protobuf field: string entity_id = 2
     */
    entityId: string;
    /**
     * The display name of the entity
     *
     * @generated from protobuf field: string entity_name = 3
     */
    entityName: string;
    /**
     * The CEL expression that references profile fields
     *
     * @generated from protobuf field: string cel_expression = 4
     */
    celExpression: string;
    /**
     * The profile fields that are referenced in the CEL expression and are changing
     *
     * @generated from protobuf field: repeated string referenced_changing_fields = 5
     */
    referencedChangingFields: string[];
    /**
     * Optional app ID for group automations (only populated for entity_type = "group_automation")
     *
     * @generated from protobuf field: string app_id = 6
     */
    appId: string;
}
/**
 * Set the avatar for a user.
 * Endpoint Requirements:
 * - The avatar must be a valid PNG, JPEG or WebP image.
 * - The avatar must be less than 1mb in size.
 * - The avatar must be a square image.
 *
 * @generated from protobuf message c1.api.user.v1.SetUserAvatarRequest
 */
export interface SetUserAvatarRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: bytes data = 2
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetUserAvatarResponse
 */
export interface SetUserAvatarResponse {
}
/**
 * Set the avatar for the current user (self).
 * Endpoint Requirements:
 * - The avatar must be a valid PNG, JPEG or WebP image.
 * - The avatar must be less than 1mb in size.
 * - The avatar must be a square image.
 *
 * @generated from protobuf message c1.api.user.v1.SetUserAvatarSelfRequest
 */
export interface SetUserAvatarSelfRequest {
    /**
     * @generated from protobuf field: bytes data = 1
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetUserAvatarSelfResponse
 */
export interface SetUserAvatarSelfResponse {
}
/**
 * Different user statuses
 *
 * @generated from protobuf enum c1.api.user.v1.UserStatus
 */
export enum UserStatus {
    /**
     * Indicates that the user account status is unknown.
     *
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * Indicates that the user account is active.
     *
     * @generated from protobuf enum value: ENABLED = 1;
     */
    ENABLED = 1,
    /**
     * Indicates that the user account is disabled.
     *
     * @generated from protobuf enum value: DISABLED = 2;
     */
    DISABLED = 2,
    /**
     * Indicates that the user account is deleted.
     *
     * @generated from protobuf enum value: DELETED = 3;
     */
    DELETED = 3
}
/**
 * @generated from protobuf enum c1.api.user.v1.UserType
 */
export enum UserType {
    /**
     * Indicates that the user type is unknown.
     *
     * @generated from protobuf enum value: USER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Indicates that the user is a system.
     *
     * @generated from protobuf enum value: USER_TYPE_SYSTEM = 1;
     */
    SYSTEM = 1,
    /**
     * Indicates that the user is a human.
     *
     * @generated from protobuf enum value: USER_TYPE_HUMAN = 2;
     */
    HUMAN = 2,
    /**
     * Indicates that the user is a service.
     *
     * @generated from protobuf enum value: USER_TYPE_SERVICE = 3;
     */
    SERVICE = 3,
    /**
     * Indicates that the user is an agent.
     *
     * @generated from protobuf enum value: USER_TYPE_AGENT = 4;
     */
    AGENT = 4
}
/**
 * UserOrigin describes where a user was created and who owns its lifecycle.
 *
 * @generated from protobuf enum c1.api.user.v1.UserOrigin
 */
export enum UserOrigin {
    /**
     * Unspecified origin, treated as DIRECTORY for backwards compatibility.
     *
     * @generated from protobuf enum value: USER_ORIGIN_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Synced from an external IdP, directory, or connector.
     *
     * @generated from protobuf enum value: USER_ORIGIN_DIRECTORY = 1;
     */
    DIRECTORY = 1,
    /**
     * Created locally within C1 (admin, user action, or API).
     *
     * @generated from protobuf enum value: USER_ORIGIN_LOCAL = 2;
     */
    LOCAL = 2,
    /**
     * Built-in C1 system identity; not deletable.
     *
     * @generated from protobuf enum value: USER_ORIGIN_SYSTEM = 3;
     */
    SYSTEM = 3
}
/**
 * @generated from protobuf enum c1.api.user.v1.AgentInstructionsType
 */
export enum AgentInstructionsType {
    /**
     * @generated from protobuf enum value: AGENT_INSTRUCTIONS_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AGENT_INSTRUCTIONS_TYPE_CONCISE = 1;
     */
    CONCISE = 1,
    /**
     * @generated from protobuf enum value: AGENT_INSTRUCTIONS_TYPE_VERBOSE = 2;
     */
    VERBOSE = 2,
    /**
     * @generated from protobuf enum value: AGENT_INSTRUCTIONS_TYPE_CUSTOM = 3;
     */
    CUSTOM = 3
}
/**
 * Represents an entity (workflow, access review, etc.) that may be affected by profile changes
 *
 * @generated from protobuf enum c1.api.user.v1.AffectedReferenceEntityType
 */
export enum AffectedReferenceEntityType {
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_WORKFLOW = 1;
     */
    WORKFLOW = 1,
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_ACCESS_REVIEW = 2;
     */
    ACCESS_REVIEW = 2,
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_ACCESS_REVIEW_TEMPLATE = 3;
     */
    ACCESS_REVIEW_TEMPLATE = 3,
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_GROUP_AUTOMATION = 4;
     */
    GROUP_AUTOMATION = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class GetEmploymentStatusSearchTermsRequest$Type extends MessageType<GetEmploymentStatusSearchTermsRequest> {
    constructor() {
        super("c1.api.user.v1.GetEmploymentStatusSearchTermsRequest", []);
    }
    create(value?: PartialMessage<GetEmploymentStatusSearchTermsRequest>): GetEmploymentStatusSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetEmploymentStatusSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetEmploymentStatusSearchTermsRequest): GetEmploymentStatusSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetEmploymentStatusSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetEmploymentStatusSearchTermsRequest
 */
export const GetEmploymentStatusSearchTermsRequest = new GetEmploymentStatusSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEmploymentStatusSearchTermsResponse$Type extends MessageType<GetEmploymentStatusSearchTermsResponse> {
    constructor() {
        super("c1.api.user.v1.GetEmploymentStatusSearchTermsResponse", [
            { no: 1, name: "terms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetEmploymentStatusSearchTermsResponse>): GetEmploymentStatusSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.terms = [];
        if (value !== undefined)
            reflectionMergePartial<GetEmploymentStatusSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetEmploymentStatusSearchTermsResponse): GetEmploymentStatusSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string terms */ 1:
                    message.terms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetEmploymentStatusSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string terms = 1; */
        for (let i = 0; i < message.terms.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.terms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetEmploymentStatusSearchTermsResponse
 */
export const GetEmploymentStatusSearchTermsResponse = new GetEmploymentStatusSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJobTitleSearchTermsRequest$Type extends MessageType<GetJobTitleSearchTermsRequest> {
    constructor() {
        super("c1.api.user.v1.GetJobTitleSearchTermsRequest", []);
    }
    create(value?: PartialMessage<GetJobTitleSearchTermsRequest>): GetJobTitleSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetJobTitleSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJobTitleSearchTermsRequest): GetJobTitleSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJobTitleSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetJobTitleSearchTermsRequest
 */
export const GetJobTitleSearchTermsRequest = new GetJobTitleSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJobTitleSearchTermsResponse$Type extends MessageType<GetJobTitleSearchTermsResponse> {
    constructor() {
        super("c1.api.user.v1.GetJobTitleSearchTermsResponse", [
            { no: 1, name: "terms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetJobTitleSearchTermsResponse>): GetJobTitleSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.terms = [];
        if (value !== undefined)
            reflectionMergePartial<GetJobTitleSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJobTitleSearchTermsResponse): GetJobTitleSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string terms */ 1:
                    message.terms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJobTitleSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string terms = 1; */
        for (let i = 0; i < message.terms.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.terms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetJobTitleSearchTermsResponse
 */
export const GetJobTitleSearchTermsResponse = new GetJobTitleSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDepartmentSearchTermsRequest$Type extends MessageType<GetDepartmentSearchTermsRequest> {
    constructor() {
        super("c1.api.user.v1.GetDepartmentSearchTermsRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetDepartmentSearchTermsRequest>): GetDepartmentSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<GetDepartmentSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDepartmentSearchTermsRequest): GetDepartmentSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDepartmentSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetDepartmentSearchTermsRequest
 */
export const GetDepartmentSearchTermsRequest = new GetDepartmentSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDepartmentSearchTermsResponse$Type extends MessageType<GetDepartmentSearchTermsResponse> {
    constructor() {
        super("c1.api.user.v1.GetDepartmentSearchTermsResponse", [
            { no: 1, name: "terms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetDepartmentSearchTermsResponse>): GetDepartmentSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.terms = [];
        if (value !== undefined)
            reflectionMergePartial<GetDepartmentSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDepartmentSearchTermsResponse): GetDepartmentSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string terms */ 1:
                    message.terms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDepartmentSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string terms = 1; */
        for (let i = 0; i < message.terms.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.terms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetDepartmentSearchTermsResponse
 */
export const GetDepartmentSearchTermsResponse = new GetDepartmentSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersWithoutManagerRequest$Type extends MessageType<CountAppUsersWithoutManagerRequest> {
    constructor() {
        super("c1.api.user.v1.CountAppUsersWithoutManagerRequest", []);
    }
    create(value?: PartialMessage<CountAppUsersWithoutManagerRequest>): CountAppUsersWithoutManagerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CountAppUsersWithoutManagerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountAppUsersWithoutManagerRequest): CountAppUsersWithoutManagerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountAppUsersWithoutManagerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.CountAppUsersWithoutManagerRequest
 */
export const CountAppUsersWithoutManagerRequest = new CountAppUsersWithoutManagerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersWithoutManagerResponse$Type extends MessageType<CountAppUsersWithoutManagerResponse> {
    constructor() {
        super("c1.api.user.v1.CountAppUsersWithoutManagerResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountAppUsersWithoutManagerResponse>): CountAppUsersWithoutManagerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountAppUsersWithoutManagerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountAppUsersWithoutManagerResponse): CountAppUsersWithoutManagerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountAppUsersWithoutManagerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.CountAppUsersWithoutManagerResponse
 */
export const CountAppUsersWithoutManagerResponse = new CountAppUsersWithoutManagerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersWithoutManagerRequest$Type extends MessageType<UsersWithoutManagerRequest> {
    constructor() {
        super("c1.api.user.v1.UsersWithoutManagerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<UsersWithoutManagerRequest>): UsersWithoutManagerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UsersWithoutManagerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsersWithoutManagerRequest): UsersWithoutManagerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 3:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsersWithoutManagerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.user.v1.UserExpandMask expand_mask = 3; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UsersWithoutManagerRequest
 */
export const UsersWithoutManagerRequest = new UsersWithoutManagerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersWithoutManagerResponse$Type extends MessageType<UsersWithoutManagerResponse> {
    constructor() {
        super("c1.api.user.v1.UsersWithoutManagerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UsersWithoutManagerResponse>): UsersWithoutManagerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UsersWithoutManagerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsersWithoutManagerResponse): UsersWithoutManagerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView list */ 1:
                    message.list.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsersWithoutManagerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UsersWithoutManagerResponse
 */
export const UsersWithoutManagerResponse = new UsersWithoutManagerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersWithUnspecifiedEmploymentStatusRequest$Type extends MessageType<UsersWithUnspecifiedEmploymentStatusRequest> {
    constructor() {
        super("c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<UsersWithUnspecifiedEmploymentStatusRequest>): UsersWithUnspecifiedEmploymentStatusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UsersWithUnspecifiedEmploymentStatusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsersWithUnspecifiedEmploymentStatusRequest): UsersWithUnspecifiedEmploymentStatusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 3:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsersWithUnspecifiedEmploymentStatusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.user.v1.UserExpandMask expand_mask = 3; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest
 */
export const UsersWithUnspecifiedEmploymentStatusRequest = new UsersWithUnspecifiedEmploymentStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersWithUnspecifiedEmploymentStatusResponse$Type extends MessageType<UsersWithUnspecifiedEmploymentStatusResponse> {
    constructor() {
        super("c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UsersWithUnspecifiedEmploymentStatusResponse>): UsersWithUnspecifiedEmploymentStatusResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UsersWithUnspecifiedEmploymentStatusResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsersWithUnspecifiedEmploymentStatusResponse): UsersWithUnspecifiedEmploymentStatusResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView list */ 1:
                    message.list.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsersWithUnspecifiedEmploymentStatusResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusResponse
 */
export const UsersWithUnspecifiedEmploymentStatusResponse = new UsersWithUnspecifiedEmploymentStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserExpandMask$Type extends MessageType<UserExpandMask> {
    constructor() {
        super("c1.api.user.v1.UserExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "role_ids", "manager_ids", "delegated_user_iddirectory_ids"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<UserExpandMask>): UserExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<UserExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserExpandMask): UserExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserExpandMask
 */
export const UserExpandMask = new UserExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserView$Type extends MessageType<UserView> {
    constructor() {
        super("c1.api.user.v1.UserView", [
            { no: 1, name: "user", kind: "message", T: () => User, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "roles_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "managers_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "delegated_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "directories_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<UserView>): UserView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rolesPath = "";
        message.managersPath = "";
        message.delegatedUserPath = "";
        message.directoriesPath = "";
        if (value !== undefined)
            reflectionMergePartial<UserView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserView): UserView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* string roles_path */ 2:
                    message.rolesPath = reader.string();
                    break;
                case /* string managers_path */ 3:
                    message.managersPath = reader.string();
                    break;
                case /* string delegated_user_path */ 4:
                    message.delegatedUserPath = reader.string();
                    break;
                case /* string directories_path */ 5:
                    message.directoriesPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string roles_path = 2; */
        if (message.rolesPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.rolesPath);
        /* string managers_path = 3; */
        if (message.managersPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.managersPath);
        /* string delegated_user_path = 4; */
        if (message.delegatedUserPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.delegatedUserPath);
        /* string directories_path = 5; */
        if (message.directoriesPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.directoriesPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserView
 */
export const UserView = new UserView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingSource$Type extends MessageType<UserAttributeMappingSource> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingSource", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingSource>): UserAttributeMappingSource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAttributeMappingId = "";
        message.appId = "";
        message.appUserId = "";
        message.appUserProfileAttributeKey = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingSource): UserAttributeMappingSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_attribute_mapping_id */ 1:
                    message.userAttributeMappingId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* string app_user_profile_attribute_key */ 4:
                    message.appUserProfileAttributeKey = reader.string();
                    break;
                case /* string value */ 5:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_attribute_mapping_id = 1; */
        if (message.userAttributeMappingId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userAttributeMappingId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* string app_user_profile_attribute_key = 4; */
        if (message.appUserProfileAttributeKey !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appUserProfileAttributeKey);
        /* string value = 5; */
        if (message.value !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingSource
 */
export const UserAttributeMappingSource = new UserAttributeMappingSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserRef$Type extends MessageType<UserRef> {
    constructor() {
        super("c1.api.user.v1.UserRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UserRef>): UserRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<UserRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserRef): UserRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserRef
 */
export const UserRef = new UserRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class User$Type extends MessageType<User> {
    constructor() {
        super("c1.api.user.v1.User", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 24, name: "emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 30, name: "email_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 25, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 26, name: "usernames", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 27, name: "username_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 28, name: "employee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 29, name: "employee_id_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "status", kind: "enum", T: () => ["c1.api.user.v1.UserStatus", UserStatus] },
            { no: 5, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "manager_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "manager_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "directory_status", kind: "enum", T: () => ["c1.api.user.v1.UserStatus", UserStatus], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "directory_status_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "job_title", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 15, name: "job_title_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 16, name: "department", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 17, name: "department_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 18, name: "employment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 19, name: "employment_status_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 20, name: "employment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 21, name: "employment_type_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 22, name: "directory_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 23, name: "profile", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 31, name: "type", kind: "enum", T: () => ["c1.api.user.v1.UserType", UserType, "USER_TYPE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 32, name: "origin", kind: "enum", T: () => ["c1.api.user.v1.UserOrigin", UserOrigin, "USER_ORIGIN_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "policy.v1.msg": { enabled: true, name: "user", keyFields: ["id"] } });
    }
    create(value?: PartialMessage<User>): User {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.email = "";
        message.emails = [];
        message.emailSources = [];
        message.username = "";
        message.usernames = [];
        message.usernameSources = [];
        message.employeeIds = [];
        message.employeeIdSources = [];
        message.status = 0;
        message.roleIds = [];
        message.managerIds = [];
        message.managerSources = [];
        message.delegatedUserId = "";
        message.directoryStatus = 0;
        message.directoryStatusSources = [];
        message.jobTitle = "";
        message.jobTitleSources = [];
        message.department = "";
        message.departmentSources = [];
        message.employmentStatus = "";
        message.employmentStatusSources = [];
        message.employmentType = "";
        message.employmentTypeSources = [];
        message.directoryIds = [];
        message.type = 0;
        message.origin = 0;
        if (value !== undefined)
            reflectionMergePartial<User>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: User): User {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string email */ 3:
                    message.email = reader.string();
                    break;
                case /* repeated string emails */ 24:
                    message.emails.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource email_sources */ 30:
                    message.emailSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string username */ 25:
                    message.username = reader.string();
                    break;
                case /* repeated string usernames */ 26:
                    message.usernames.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource username_sources */ 27:
                    message.usernameSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string employee_ids */ 28:
                    message.employeeIds.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource employee_id_sources */ 29:
                    message.employeeIdSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.user.v1.UserStatus status */ 4:
                    message.status = reader.int32();
                    break;
                case /* repeated string role_ids */ 5:
                    message.roleIds.push(reader.string());
                    break;
                case /* repeated string manager_ids */ 6:
                    message.managerIds.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource manager_sources */ 11:
                    message.managerSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 9:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string delegated_user_id */ 10:
                    message.delegatedUserId = reader.string();
                    break;
                case /* c1.api.user.v1.UserStatus directory_status */ 12:
                    message.directoryStatus = reader.int32();
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource directory_status_sources */ 13:
                    message.directoryStatusSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string job_title */ 14:
                    message.jobTitle = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource job_title_sources */ 15:
                    message.jobTitleSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string department */ 16:
                    message.department = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource department_sources */ 17:
                    message.departmentSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string employment_status */ 18:
                    message.employmentStatus = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource employment_status_sources */ 19:
                    message.employmentStatusSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string employment_type */ 20:
                    message.employmentType = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource employment_type_sources */ 21:
                    message.employmentTypeSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string directory_ids */ 22:
                    message.directoryIds.push(reader.string());
                    break;
                case /* google.protobuf.Struct profile */ 23:
                    message.profile = Struct.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                case /* c1.api.user.v1.UserType type */ 31:
                    message.type = reader.int32();
                    break;
                case /* c1.api.user.v1.UserOrigin origin */ 32:
                    message.origin = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: User, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string email = 3; */
        if (message.email !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.email);
        /* c1.api.user.v1.UserStatus status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* repeated string role_ids = 5; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.roleIds[i]);
        /* repeated string manager_ids = 6; */
        for (let i = 0; i < message.managerIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.managerIds[i]);
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 9; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string delegated_user_id = 10; */
        if (message.delegatedUserId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.delegatedUserId);
        /* repeated c1.api.user.v1.UserAttributeMappingSource manager_sources = 11; */
        for (let i = 0; i < message.managerSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.managerSources[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserStatus directory_status = 12; */
        if (message.directoryStatus !== 0)
            writer.tag(12, WireType.Varint).int32(message.directoryStatus);
        /* repeated c1.api.user.v1.UserAttributeMappingSource directory_status_sources = 13; */
        for (let i = 0; i < message.directoryStatusSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.directoryStatusSources[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string job_title = 14; */
        if (message.jobTitle !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.jobTitle);
        /* repeated c1.api.user.v1.UserAttributeMappingSource job_title_sources = 15; */
        for (let i = 0; i < message.jobTitleSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.jobTitleSources[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string department = 16; */
        if (message.department !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.department);
        /* repeated c1.api.user.v1.UserAttributeMappingSource department_sources = 17; */
        for (let i = 0; i < message.departmentSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.departmentSources[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* string employment_status = 18; */
        if (message.employmentStatus !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.employmentStatus);
        /* repeated c1.api.user.v1.UserAttributeMappingSource employment_status_sources = 19; */
        for (let i = 0; i < message.employmentStatusSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.employmentStatusSources[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* string employment_type = 20; */
        if (message.employmentType !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.employmentType);
        /* repeated c1.api.user.v1.UserAttributeMappingSource employment_type_sources = 21; */
        for (let i = 0; i < message.employmentTypeSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.employmentTypeSources[i], writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* repeated string directory_ids = 22; */
        for (let i = 0; i < message.directoryIds.length; i++)
            writer.tag(22, WireType.LengthDelimited).string(message.directoryIds[i]);
        /* google.protobuf.Struct profile = 23; */
        if (message.profile)
            Struct.internalBinaryWrite(message.profile, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* repeated string emails = 24; */
        for (let i = 0; i < message.emails.length; i++)
            writer.tag(24, WireType.LengthDelimited).string(message.emails[i]);
        /* string username = 25; */
        if (message.username !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.username);
        /* repeated string usernames = 26; */
        for (let i = 0; i < message.usernames.length; i++)
            writer.tag(26, WireType.LengthDelimited).string(message.usernames[i]);
        /* repeated c1.api.user.v1.UserAttributeMappingSource username_sources = 27; */
        for (let i = 0; i < message.usernameSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.usernameSources[i], writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* repeated string employee_ids = 28; */
        for (let i = 0; i < message.employeeIds.length; i++)
            writer.tag(28, WireType.LengthDelimited).string(message.employeeIds[i]);
        /* repeated c1.api.user.v1.UserAttributeMappingSource employee_id_sources = 29; */
        for (let i = 0; i < message.employeeIdSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.employeeIdSources[i], writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserAttributeMappingSource email_sources = 30; */
        for (let i = 0; i < message.emailSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.emailSources[i], writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserType type = 31; */
        if (message.type !== 0)
            writer.tag(31, WireType.Varint).int32(message.type);
        /* c1.api.user.v1.UserOrigin origin = 32; */
        if (message.origin !== 0)
            writer.tag(32, WireType.Varint).int32(message.origin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.User
 */
export const User = new User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpiringUserDelegationBinding$Type extends MessageType<ExpiringUserDelegationBinding> {
    constructor() {
        super("c1.api.user.v1.ExpiringUserDelegationBinding", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "start_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "expiration_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ExpiringUserDelegationBinding>): ExpiringUserDelegationBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.delegatedUserId = "";
        if (value !== undefined)
            reflectionMergePartial<ExpiringUserDelegationBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpiringUserDelegationBinding): ExpiringUserDelegationBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string delegated_user_id */ 2:
                    message.delegatedUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp start_at */ 3:
                    message.startAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startAt);
                    break;
                case /* google.protobuf.Timestamp expiration_at */ 4:
                    message.expirationAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expirationAt);
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpiringUserDelegationBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string delegated_user_id = 2; */
        if (message.delegatedUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.delegatedUserId);
        /* google.protobuf.Timestamp start_at = 3; */
        if (message.startAt)
            Timestamp.internalBinaryWrite(message.startAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expiration_at = 4; */
        if (message.expirationAt)
            Timestamp.internalBinaryWrite(message.expirationAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.ExpiringUserDelegationBinding
 */
export const ExpiringUserDelegationBinding = new ExpiringUserDelegationBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectRequest$Type extends MessageType<IntrospectRequest> {
    constructor() {
        super("c1.api.user.v1.IntrospectRequest", [
            { no: 1, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<IntrospectRequest>): IntrospectRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<IntrospectRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IntrospectRequest): IntrospectRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 1:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IntrospectRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserExpandMask expand_mask = 1; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.IntrospectRequest
 */
export const IntrospectRequest = new IntrospectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectResponse$Type extends MessageType<IntrospectResponse> {
    constructor() {
        super("c1.api.user.v1.IntrospectResponse", [
            { no: 1, name: "user_view", kind: "message", T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<IntrospectResponse>): IntrospectResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<IntrospectResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IntrospectResponse): IntrospectResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserView user_view */ 1:
                    message.userView = UserView.internalBinaryRead(reader, reader.uint32(), options, message.userView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IntrospectResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserView user_view = 1; */
        if (message.userView)
            UserView.internalBinaryWrite(message.userView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.IntrospectResponse
 */
export const IntrospectResponse = new IntrospectResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceGetRequest$Type extends MessageType<UserServiceGetRequest> {
    constructor() {
        super("c1.api.user.v1.UserServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<UserServiceGetRequest>): UserServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<UserServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserServiceGetRequest): UserServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 2:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.user.v1.UserExpandMask expand_mask = 2; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceGetRequest
 */
export const UserServiceGetRequest = new UserServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceGetResponse$Type extends MessageType<UserServiceGetResponse> {
    constructor() {
        super("c1.api.user.v1.UserServiceGetResponse", [
            { no: 1, name: "user_view", kind: "message", T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UserServiceGetResponse>): UserServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UserServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserServiceGetResponse): UserServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserView user_view */ 1:
                    message.userView = UserView.internalBinaryRead(reader, reader.uint32(), options, message.userView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserView user_view = 1; */
        if (message.userView)
            UserView.internalBinaryWrite(message.userView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceGetResponse
 */
export const UserServiceGetResponse = new UserServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceGetUsersByIDsRequest$Type extends MessageType<UserServiceGetUsersByIDsRequest> {
    constructor() {
        super("c1.api.user.v1.UserServiceGetUsersByIDsRequest", [
            { no: 1, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<UserServiceGetUsersByIDsRequest>): UserServiceGetUsersByIDsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<UserServiceGetUsersByIDsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserServiceGetUsersByIDsRequest): UserServiceGetUsersByIDsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string ids */ 1:
                    message.ids.push(reader.string());
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 2:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserServiceGetUsersByIDsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.ids[i]);
        /* c1.api.user.v1.UserExpandMask expand_mask = 2; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceGetUsersByIDsRequest
 */
export const UserServiceGetUsersByIDsRequest = new UserServiceGetUsersByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceGetUsersByIDsResponse$Type extends MessageType<UserServiceGetUsersByIDsResponse> {
    constructor() {
        super("c1.api.user.v1.UserServiceGetUsersByIDsResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UserServiceGetUsersByIDsResponse>): UserServiceGetUsersByIDsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UserServiceGetUsersByIDsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserServiceGetUsersByIDsResponse): UserServiceGetUsersByIDsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView items */ 1:
                    message.items.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserServiceGetUsersByIDsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView items = 1; */
        for (let i = 0; i < message.items.length; i++)
            UserView.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceGetUsersByIDsResponse
 */
export const UserServiceGetUsersByIDsResponse = new UserServiceGetUsersByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceListRequest$Type extends MessageType<UserServiceListRequest> {
    constructor() {
        super("c1.api.user.v1.UserServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<UserServiceListRequest>): UserServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserServiceListRequest): UserServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 3:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.user.v1.UserExpandMask expand_mask = 3; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceListRequest
 */
export const UserServiceListRequest = new UserServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceListResponse$Type extends MessageType<UserServiceListResponse> {
    constructor() {
        super("c1.api.user.v1.UserServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserServiceListResponse>): UserServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserServiceListResponse): UserServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView list */ 1:
                    message.list.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceListResponse
 */
export const UserServiceListResponse = new UserServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersRequest$Type extends MessageType<SearchUsersRequest> {
    constructor() {
        super("c1.api.user.v1.SearchUsersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 7, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 8, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } },
            { no: 9, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 12, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { email: true, ignoreEmpty: true } } } },
            { no: 13, name: "exclude_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserType", UserType, "USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } },
            { no: 14, name: "manager_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 15, name: "job_titles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minLen: "1", maxLen: "255" } } } } } },
            { no: 16, name: "departments", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minLen: "1", maxLen: "255" } } } } } },
            { no: 17, name: "origins", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserOrigin", UserOrigin, "USER_ORIGIN_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 18, name: "exclude_origins", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserOrigin", UserOrigin, "USER_ORIGIN_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchUsersRequest>): SearchUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.userStatuses = [];
        message.roleIds = [];
        message.excludeIds = [];
        message.ids = [];
        message.refs = [];
        message.email = "";
        message.excludeTypes = [];
        message.managerIds = [];
        message.jobTitles = [];
        message.departments = [];
        message.origins = [];
        message.excludeOrigins = [];
        if (value !== undefined)
            reflectionMergePartial<SearchUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsersRequest): SearchUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 6:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.user.v1.UserStatus user_statuses */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userStatuses.push(reader.int32());
                    else
                        message.userStatuses.push(reader.int32());
                    break;
                case /* repeated string role_ids */ 8:
                    message.roleIds.push(reader.string());
                    break;
                case /* repeated string exclude_ids */ 9:
                    message.excludeIds.push(reader.string());
                    break;
                case /* repeated string ids */ 10:
                    message.ids.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.UserRef refs */ 11:
                    message.refs.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string email */ 12:
                    message.email = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserType exclude_types */ 13:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.excludeTypes.push(reader.int32());
                    else
                        message.excludeTypes.push(reader.int32());
                    break;
                case /* repeated string manager_ids */ 14:
                    message.managerIds.push(reader.string());
                    break;
                case /* repeated string job_titles */ 15:
                    message.jobTitles.push(reader.string());
                    break;
                case /* repeated string departments */ 16:
                    message.departments.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.UserOrigin origins */ 17:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.origins.push(reader.int32());
                    else
                        message.origins.push(reader.int32());
                    break;
                case /* repeated c1.api.user.v1.UserOrigin exclude_origins */ 18:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.excludeOrigins.push(reader.int32());
                    else
                        message.excludeOrigins.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* c1.api.user.v1.UserExpandMask expand_mask = 6; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserStatus user_statuses = 7; */
        if (message.userStatuses.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userStatuses.length; i++)
                writer.int32(message.userStatuses[i]);
            writer.join();
        }
        /* repeated string role_ids = 8; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.roleIds[i]);
        /* repeated string exclude_ids = 9; */
        for (let i = 0; i < message.excludeIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.excludeIds[i]);
        /* repeated string ids = 10; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.ids[i]);
        /* repeated c1.api.user.v1.UserRef refs = 11; */
        for (let i = 0; i < message.refs.length; i++)
            UserRef.internalBinaryWrite(message.refs[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string email = 12; */
        if (message.email !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.email);
        /* repeated c1.api.user.v1.UserType exclude_types = 13; */
        if (message.excludeTypes.length) {
            writer.tag(13, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.excludeTypes.length; i++)
                writer.int32(message.excludeTypes[i]);
            writer.join();
        }
        /* repeated string manager_ids = 14; */
        for (let i = 0; i < message.managerIds.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.managerIds[i]);
        /* repeated string job_titles = 15; */
        for (let i = 0; i < message.jobTitles.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.jobTitles[i]);
        /* repeated string departments = 16; */
        for (let i = 0; i < message.departments.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.departments[i]);
        /* repeated c1.api.user.v1.UserOrigin origins = 17; */
        if (message.origins.length) {
            writer.tag(17, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.origins.length; i++)
                writer.int32(message.origins[i]);
            writer.join();
        }
        /* repeated c1.api.user.v1.UserOrigin exclude_origins = 18; */
        if (message.excludeOrigins.length) {
            writer.tag(18, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.excludeOrigins.length; i++)
                writer.int32(message.excludeOrigins[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUsersRequest
 */
export const SearchUsersRequest = new SearchUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersResponse$Type extends MessageType<SearchUsersResponse> {
    constructor() {
        super("c1.api.user.v1.SearchUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchUsersResponse>): SearchUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsersResponse): SearchUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView list */ 1:
                    message.list.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUsersResponse
 */
export const SearchUsersResponse = new SearchUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManagedUsersRequest$Type extends MessageType<SearchManagedUsersRequest> {
    constructor() {
        super("c1.api.user.v1.SearchManagedUsersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "manager_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "exclude_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 8, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } }
        ]);
    }
    create(value?: PartialMessage<SearchManagedUsersRequest>): SearchManagedUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.managerId = "";
        message.query = "";
        message.excludeUserIds = [];
        message.userIds = [];
        message.userStatuses = [];
        message.roleIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchManagedUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchManagedUsersRequest): SearchManagedUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string manager_id */ 3:
                    message.managerId = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_user_ids */ 5:
                    message.excludeUserIds.push(reader.string());
                    break;
                case /* repeated string user_ids */ 6:
                    message.userIds.push(reader.string());
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 7:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.user.v1.UserStatus user_statuses */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userStatuses.push(reader.int32());
                    else
                        message.userStatuses.push(reader.int32());
                    break;
                case /* repeated string role_ids */ 9:
                    message.roleIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchManagedUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string manager_id = 3; */
        if (message.managerId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.managerId);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_user_ids = 5; */
        for (let i = 0; i < message.excludeUserIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.excludeUserIds[i]);
        /* repeated string user_ids = 6; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.userIds[i]);
        /* c1.api.user.v1.UserExpandMask expand_mask = 7; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserStatus user_statuses = 8; */
        if (message.userStatuses.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userStatuses.length; i++)
                writer.int32(message.userStatuses[i]);
            writer.join();
        }
        /* repeated string role_ids = 9; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.roleIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchManagedUsersRequest
 */
export const SearchManagedUsersRequest = new SearchManagedUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManagedUsersResponse$Type extends MessageType<SearchManagedUsersResponse> {
    constructor() {
        super("c1.api.user.v1.SearchManagedUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchManagedUsersResponse>): SearchManagedUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchManagedUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchManagedUsersResponse): SearchManagedUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView list */ 1:
                    message.list.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchManagedUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchManagedUsersResponse
 */
export const SearchManagedUsersResponse = new SearchManagedUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManagedUsersForAccessRequestsRequest$Type extends MessageType<SearchManagedUsersForAccessRequestsRequest> {
    constructor() {
        super("c1.api.user.v1.SearchManagedUsersForAccessRequestsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "manager_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "exclude_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 8, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } }
        ]);
    }
    create(value?: PartialMessage<SearchManagedUsersForAccessRequestsRequest>): SearchManagedUsersForAccessRequestsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.managerId = "";
        message.query = "";
        message.excludeUserIds = [];
        message.userIds = [];
        message.userStatuses = [];
        message.roleIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchManagedUsersForAccessRequestsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchManagedUsersForAccessRequestsRequest): SearchManagedUsersForAccessRequestsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string manager_id */ 3:
                    message.managerId = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_user_ids */ 5:
                    message.excludeUserIds.push(reader.string());
                    break;
                case /* repeated string user_ids */ 6:
                    message.userIds.push(reader.string());
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 7:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.user.v1.UserStatus user_statuses */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userStatuses.push(reader.int32());
                    else
                        message.userStatuses.push(reader.int32());
                    break;
                case /* repeated string role_ids */ 9:
                    message.roleIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchManagedUsersForAccessRequestsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string manager_id = 3; */
        if (message.managerId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.managerId);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_user_ids = 5; */
        for (let i = 0; i < message.excludeUserIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.excludeUserIds[i]);
        /* repeated string user_ids = 6; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.userIds[i]);
        /* c1.api.user.v1.UserExpandMask expand_mask = 7; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserStatus user_statuses = 8; */
        if (message.userStatuses.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userStatuses.length; i++)
                writer.int32(message.userStatuses[i]);
            writer.join();
        }
        /* repeated string role_ids = 9; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.roleIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchManagedUsersForAccessRequestsRequest
 */
export const SearchManagedUsersForAccessRequestsRequest = new SearchManagedUsersForAccessRequestsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManagedUsersForAccessRequestsResponse$Type extends MessageType<SearchManagedUsersForAccessRequestsResponse> {
    constructor() {
        super("c1.api.user.v1.SearchManagedUsersForAccessRequestsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchManagedUsersForAccessRequestsResponse>): SearchManagedUsersForAccessRequestsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchManagedUsersForAccessRequestsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchManagedUsersForAccessRequestsResponse): SearchManagedUsersForAccessRequestsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView list */ 1:
                    message.list.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchManagedUsersForAccessRequestsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchManagedUsersForAccessRequestsResponse
 */
export const SearchManagedUsersForAccessRequestsResponse = new SearchManagedUsersForAccessRequestsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserRequest$Type extends MessageType<UpdateUserRequest> {
    constructor() {
        super("c1.api.user.v1.UpdateUserRequest", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<UpdateUserRequest>): UpdateUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateUserRequest): UpdateUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 3:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserExpandMask expand_mask = 3; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UpdateUserRequest
 */
export const UpdateUserRequest = new UpdateUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDelegatedUserRequest$Type extends MessageType<SetDelegatedUserRequest> {
    constructor() {
        super("c1.api.user.v1.SetDelegatedUserRequest", [
            { no: 1, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<SetDelegatedUserRequest>): SetDelegatedUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.delegatedUserId = "";
        if (value !== undefined)
            reflectionMergePartial<SetDelegatedUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetDelegatedUserRequest): SetDelegatedUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string delegated_user_id */ 1:
                    message.delegatedUserId = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 2:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetDelegatedUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string delegated_user_id = 1; */
        if (message.delegatedUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.delegatedUserId);
        /* c1.api.user.v1.UserExpandMask expand_mask = 2; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetDelegatedUserRequest
 */
export const SetDelegatedUserRequest = new SetDelegatedUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserRolesRequest$Type extends MessageType<SetUserRolesRequest> {
    constructor() {
        super("c1.api.user.v1.SetUserRolesRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
    create(value?: PartialMessage<SetUserRolesRequest>): SetUserRolesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.roleIds = [];
        if (value !== undefined)
            reflectionMergePartial<SetUserRolesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetUserRolesRequest): SetUserRolesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* repeated string role_ids */ 2:
                    message.roleIds.push(reader.string());
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 3:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetUserRolesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* repeated string role_ids = 2; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.roleIds[i]);
        /* c1.api.user.v1.UserExpandMask expand_mask = 3; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserRolesRequest
 */
export const SetUserRolesRequest = new SetUserRolesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersWithCELRequest$Type extends MessageType<SearchUsersWithCELRequest> {
    constructor() {
        super("c1.api.user.v1.SearchUsersWithCELRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 5, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { email: true, ignoreEmpty: true } } } },
            { no: 6, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0" } } } },
            { no: 7, name: "exclude_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchUsersWithCELRequest>): SearchUsersWithCELRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.email = "";
        message.expression = "";
        message.excludeUserIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchUsersWithCELRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsersWithCELRequest): SearchUsersWithCELRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 4:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string email */ 5:
                    message.email = reader.string();
                    break;
                case /* string expression */ 6:
                    message.expression = reader.string();
                    break;
                case /* repeated string exclude_user_ids */ 7:
                    message.excludeUserIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsersWithCELRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* c1.api.user.v1.UserExpandMask expand_mask = 4; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string email = 5; */
        if (message.email !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.email);
        /* string expression = 6; */
        if (message.expression !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.expression);
        /* repeated string exclude_user_ids = 7; */
        for (let i = 0; i < message.excludeUserIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.excludeUserIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUsersWithCELRequest
 */
export const SearchUsersWithCELRequest = new SearchUsersWithCELRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersWithCELResponse$Type extends MessageType<SearchUsersWithCELResponse> {
    constructor() {
        super("c1.api.user.v1.SearchUsersWithCELResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchUsersWithCELResponse>): SearchUsersWithCELResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchUsersWithCELResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsersWithCELResponse): SearchUsersWithCELResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView list */ 1:
                    message.list.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsersWithCELResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUsersWithCELResponse
 */
export const SearchUsersWithCELResponse = new SearchUsersWithCELResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamSearchUsersWithCELRequest$Type extends MessageType<StreamSearchUsersWithCELRequest> {
    constructor() {
        super("c1.api.user.v1.StreamSearchUsersWithCELRequest", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "exclude_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<StreamSearchUsersWithCELRequest>): StreamSearchUsersWithCELRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        message.excludeUserIds = [];
        if (value !== undefined)
            reflectionMergePartial<StreamSearchUsersWithCELRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamSearchUsersWithCELRequest): StreamSearchUsersWithCELRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                case /* repeated string exclude_user_ids */ 2:
                    message.excludeUserIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamSearchUsersWithCELRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        /* repeated string exclude_user_ids = 2; */
        for (let i = 0; i < message.excludeUserIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.excludeUserIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.StreamSearchUsersWithCELRequest
 */
export const StreamSearchUsersWithCELRequest = new StreamSearchUsersWithCELRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamSearchUsersWithCELResponse$Type extends MessageType<StreamSearchUsersWithCELResponse> {
    constructor() {
        super("c1.api.user.v1.StreamSearchUsersWithCELResponse", [
            { no: 1, name: "matched", kind: "message", oneof: "response", T: () => StreamSearchUsersWithCELResponse_Matched },
            { no: 2, name: "status", kind: "message", oneof: "response", T: () => StreamSearchUsersWithCELResponse_Status },
            { no: 3, name: "failed", kind: "message", oneof: "response", T: () => StreamSearchUsersWithCELResponse_Failed },
            { no: 4, name: "stopped", kind: "scalar", oneof: "response", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<StreamSearchUsersWithCELResponse>): StreamSearchUsersWithCELResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<StreamSearchUsersWithCELResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamSearchUsersWithCELResponse): StreamSearchUsersWithCELResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.StreamSearchUsersWithCELResponse.Matched matched */ 1:
                    message.response = {
                        oneofKind: "matched",
                        matched: StreamSearchUsersWithCELResponse_Matched.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).matched)
                    };
                    break;
                case /* c1.api.user.v1.StreamSearchUsersWithCELResponse.Status status */ 2:
                    message.response = {
                        oneofKind: "status",
                        status: StreamSearchUsersWithCELResponse_Status.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).status)
                    };
                    break;
                case /* c1.api.user.v1.StreamSearchUsersWithCELResponse.Failed failed */ 3:
                    message.response = {
                        oneofKind: "failed",
                        failed: StreamSearchUsersWithCELResponse_Failed.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).failed)
                    };
                    break;
                case /* bool stopped */ 4:
                    message.response = {
                        oneofKind: "stopped",
                        stopped: reader.bool()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamSearchUsersWithCELResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.StreamSearchUsersWithCELResponse.Matched matched = 1; */
        if (message.response.oneofKind === "matched")
            StreamSearchUsersWithCELResponse_Matched.internalBinaryWrite(message.response.matched, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.StreamSearchUsersWithCELResponse.Status status = 2; */
        if (message.response.oneofKind === "status")
            StreamSearchUsersWithCELResponse_Status.internalBinaryWrite(message.response.status, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.StreamSearchUsersWithCELResponse.Failed failed = 3; */
        if (message.response.oneofKind === "failed")
            StreamSearchUsersWithCELResponse_Failed.internalBinaryWrite(message.response.failed, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool stopped = 4; */
        if (message.response.oneofKind === "stopped")
            writer.tag(4, WireType.Varint).bool(message.response.stopped);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.StreamSearchUsersWithCELResponse
 */
export const StreamSearchUsersWithCELResponse = new StreamSearchUsersWithCELResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamSearchUsersWithCELResponse_Matched$Type extends MessageType<StreamSearchUsersWithCELResponse_Matched> {
    constructor() {
        super("c1.api.user.v1.StreamSearchUsersWithCELResponse.Matched", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<StreamSearchUsersWithCELResponse_Matched>): StreamSearchUsersWithCELResponse_Matched {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<StreamSearchUsersWithCELResponse_Matched>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamSearchUsersWithCELResponse_Matched): StreamSearchUsersWithCELResponse_Matched {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamSearchUsersWithCELResponse_Matched, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.StreamSearchUsersWithCELResponse.Matched
 */
export const StreamSearchUsersWithCELResponse_Matched = new StreamSearchUsersWithCELResponse_Matched$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamSearchUsersWithCELResponse_Status$Type extends MessageType<StreamSearchUsersWithCELResponse_Status> {
    constructor() {
        super("c1.api.user.v1.StreamSearchUsersWithCELResponse.Status", [
            { no: 1, name: "total", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "scanned", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "matched", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "errors", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<StreamSearchUsersWithCELResponse_Status>): StreamSearchUsersWithCELResponse_Status {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.total = 0;
        message.scanned = 0;
        message.matched = 0;
        message.errors = 0;
        if (value !== undefined)
            reflectionMergePartial<StreamSearchUsersWithCELResponse_Status>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamSearchUsersWithCELResponse_Status): StreamSearchUsersWithCELResponse_Status {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 total */ 1:
                    message.total = reader.int64().toNumber();
                    break;
                case /* int64 scanned */ 2:
                    message.scanned = reader.int64().toNumber();
                    break;
                case /* int64 matched */ 3:
                    message.matched = reader.int64().toNumber();
                    break;
                case /* int64 errors */ 4:
                    message.errors = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamSearchUsersWithCELResponse_Status, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 total = 1; */
        if (message.total !== 0)
            writer.tag(1, WireType.Varint).int64(message.total);
        /* int64 scanned = 2; */
        if (message.scanned !== 0)
            writer.tag(2, WireType.Varint).int64(message.scanned);
        /* int64 matched = 3; */
        if (message.matched !== 0)
            writer.tag(3, WireType.Varint).int64(message.matched);
        /* int64 errors = 4; */
        if (message.errors !== 0)
            writer.tag(4, WireType.Varint).int64(message.errors);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.StreamSearchUsersWithCELResponse.Status
 */
export const StreamSearchUsersWithCELResponse_Status = new StreamSearchUsersWithCELResponse_Status$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamSearchUsersWithCELResponse_Failed$Type extends MessageType<StreamSearchUsersWithCELResponse_Failed> {
    constructor() {
        super("c1.api.user.v1.StreamSearchUsersWithCELResponse.Failed", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StreamSearchUsersWithCELResponse_Failed>): StreamSearchUsersWithCELResponse_Failed {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<StreamSearchUsersWithCELResponse_Failed>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamSearchUsersWithCELResponse_Failed): StreamSearchUsersWithCELResponse_Failed {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* string error */ 2:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamSearchUsersWithCELResponse_Failed, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string error = 2; */
        if (message.error !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.StreamSearchUsersWithCELResponse.Failed
 */
export const StreamSearchUsersWithCELResponse_Failed = new StreamSearchUsersWithCELResponse_Failed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeWithProfileTypeSource$Type extends MessageType<UserAttributeWithProfileTypeSource> {
    constructor() {
        super("c1.api.user.v1.UserAttributeWithProfileTypeSource", [
            { no: 1, name: "profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "profile_attribute_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "profile_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileType }
        ]);
    }
    create(value?: PartialMessage<UserAttributeWithProfileTypeSource>): UserAttributeWithProfileTypeSource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profileAttributeKey = "";
        message.profileAttributeValue = "";
        message.profileTypes = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeWithProfileTypeSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeWithProfileTypeSource): UserAttributeWithProfileTypeSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string profile_attribute_key */ 1:
                    message.profileAttributeKey = reader.string();
                    break;
                case /* string profile_attribute_value */ 2:
                    message.profileAttributeValue = reader.string();
                    break;
                case /* repeated c1.api.profiletype.v1.ProfileType profile_types */ 3:
                    message.profileTypes.push(ProfileType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeWithProfileTypeSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string profile_attribute_key = 1; */
        if (message.profileAttributeKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.profileAttributeKey);
        /* string profile_attribute_value = 2; */
        if (message.profileAttributeValue !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.profileAttributeValue);
        /* repeated c1.api.profiletype.v1.ProfileType profile_types = 3; */
        for (let i = 0; i < message.profileTypes.length; i++)
            ProfileType.internalBinaryWrite(message.profileTypes[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeWithProfileTypeSource
 */
export const UserAttributeWithProfileTypeSource = new UserAttributeWithProfileTypeSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUserAttributesWithProfileTypeSourceRequest$Type extends MessageType<SearchUserAttributesWithProfileTypeSourceRequest> {
    constructor() {
        super("c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchUserAttributesWithProfileTypeSourceRequest>): SearchUserAttributesWithProfileTypeSourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchUserAttributesWithProfileTypeSourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUserAttributesWithProfileTypeSourceRequest): SearchUserAttributesWithProfileTypeSourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUserAttributesWithProfileTypeSourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceRequest
 */
export const SearchUserAttributesWithProfileTypeSourceRequest = new SearchUserAttributesWithProfileTypeSourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUserAttributesWithProfileTypeSourceResponse$Type extends MessageType<SearchUserAttributesWithProfileTypeSourceResponse> {
    constructor() {
        super("c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeWithProfileTypeSource }
        ]);
    }
    create(value?: PartialMessage<SearchUserAttributesWithProfileTypeSourceResponse>): SearchUserAttributesWithProfileTypeSourceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<SearchUserAttributesWithProfileTypeSourceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUserAttributesWithProfileTypeSourceResponse): SearchUserAttributesWithProfileTypeSourceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserAttributeWithProfileTypeSource list */ 1:
                    message.list.push(UserAttributeWithProfileTypeSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUserAttributesWithProfileTypeSourceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserAttributeWithProfileTypeSource list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAttributeWithProfileTypeSource.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceResponse
 */
export const SearchUserAttributesWithProfileTypeSourceResponse = new SearchUserAttributesWithProfileTypeSourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentView$Type extends MessageType<AgentView> {
    constructor() {
        super("c1.api.user.v1.AgentView", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "agent_instructions_type", kind: "enum", T: () => ["c1.api.user.v1.AgentInstructionsType", AgentInstructionsType, "AGENT_INSTRUCTIONS_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<AgentView>): AgentView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.instructions = "";
        message.id = "";
        message.agentInstructionsType = 0;
        if (value !== undefined)
            reflectionMergePartial<AgentView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentView): AgentView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* string instructions */ 2:
                    message.instructions = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* c1.api.user.v1.AgentInstructionsType agent_instructions_type */ 4:
                    message.agentInstructionsType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string instructions = 2; */
        if (message.instructions !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.instructions);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* c1.api.user.v1.AgentInstructionsType agent_instructions_type = 4; */
        if (message.agentInstructionsType !== 0)
            writer.tag(4, WireType.Varint).int32(message.agentInstructionsType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.AgentView
 */
export const AgentView = new AgentView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAgentRequest$Type extends MessageType<CreateAgentRequest> {
    constructor() {
        super("c1.api.user.v1.CreateAgentRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAgentRequest>): CreateAgentRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAgentRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAgentRequest): CreateAgentRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAgentRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.CreateAgentRequest
 */
export const CreateAgentRequest = new CreateAgentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAgentResponse$Type extends MessageType<CreateAgentResponse> {
    constructor() {
        super("c1.api.user.v1.CreateAgentResponse", [
            { no: 1, name: "agent_view", kind: "message", T: () => AgentView }
        ]);
    }
    create(value?: PartialMessage<CreateAgentResponse>): CreateAgentResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateAgentResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAgentResponse): CreateAgentResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.AgentView agent_view */ 1:
                    message.agentView = AgentView.internalBinaryRead(reader, reader.uint32(), options, message.agentView);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAgentResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.AgentView agent_view = 1; */
        if (message.agentView)
            AgentView.internalBinaryWrite(message.agentView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.CreateAgentResponse
 */
export const CreateAgentResponse = new CreateAgentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgentRequest$Type extends MessageType<GetAgentRequest> {
    constructor() {
        super("c1.api.user.v1.GetAgentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAgentRequest>): GetAgentRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetAgentRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgentRequest): GetAgentRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgentRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetAgentRequest
 */
export const GetAgentRequest = new GetAgentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgentResponse$Type extends MessageType<GetAgentResponse> {
    constructor() {
        super("c1.api.user.v1.GetAgentResponse", [
            { no: 1, name: "agent_view", kind: "message", T: () => AgentView }
        ]);
    }
    create(value?: PartialMessage<GetAgentResponse>): GetAgentResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgentResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgentResponse): GetAgentResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.AgentView agent_view */ 1:
                    message.agentView = AgentView.internalBinaryRead(reader, reader.uint32(), options, message.agentView);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgentResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.AgentView agent_view = 1; */
        if (message.agentView)
            AgentView.internalBinaryWrite(message.agentView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetAgentResponse
 */
export const GetAgentResponse = new GetAgentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAgentsRequest$Type extends MessageType<ListAgentsRequest> {
    constructor() {
        super("c1.api.user.v1.ListAgentsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAgentsRequest>): ListAgentsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAgentsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAgentsRequest): ListAgentsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAgentsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.ListAgentsRequest
 */
export const ListAgentsRequest = new ListAgentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAgentsResponse$Type extends MessageType<ListAgentsResponse> {
    constructor() {
        super("c1.api.user.v1.ListAgentsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AgentView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAgentsResponse>): ListAgentsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAgentsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAgentsResponse): ListAgentsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.AgentView list */ 1:
                    message.list.push(AgentView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAgentsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.AgentView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AgentView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.ListAgentsResponse
 */
export const ListAgentsResponse = new ListAgentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAgentInstructionsRequest$Type extends MessageType<SetAgentInstructionsRequest> {
    constructor() {
        super("c1.api.user.v1.SetAgentInstructionsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "agent_instructions_type", kind: "enum", T: () => ["c1.api.user.v1.AgentInstructionsType", AgentInstructionsType, "AGENT_INSTRUCTIONS_TYPE_"], options: { "validate.rules": { enum: { definedOnly: true } } } }
        ]);
    }
    create(value?: PartialMessage<SetAgentInstructionsRequest>): SetAgentInstructionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.instructions = "";
        message.agentInstructionsType = 0;
        if (value !== undefined)
            reflectionMergePartial<SetAgentInstructionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAgentInstructionsRequest): SetAgentInstructionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string instructions */ 2:
                    message.instructions = reader.string();
                    break;
                case /* c1.api.user.v1.AgentInstructionsType agent_instructions_type */ 3:
                    message.agentInstructionsType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAgentInstructionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string instructions = 2; */
        if (message.instructions !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.instructions);
        /* c1.api.user.v1.AgentInstructionsType agent_instructions_type = 3; */
        if (message.agentInstructionsType !== 0)
            writer.tag(3, WireType.Varint).int32(message.agentInstructionsType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetAgentInstructionsRequest
 */
export const SetAgentInstructionsRequest = new SetAgentInstructionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAgentInstructionsResponse$Type extends MessageType<SetAgentInstructionsResponse> {
    constructor() {
        super("c1.api.user.v1.SetAgentInstructionsResponse", [
            { no: 1, name: "agent_view", kind: "message", T: () => AgentView }
        ]);
    }
    create(value?: PartialMessage<SetAgentInstructionsResponse>): SetAgentInstructionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetAgentInstructionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAgentInstructionsResponse): SetAgentInstructionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.AgentView agent_view */ 1:
                    message.agentView = AgentView.internalBinaryRead(reader, reader.uint32(), options, message.agentView);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAgentInstructionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.AgentView agent_view = 1; */
        if (message.agentView)
            AgentView.internalBinaryWrite(message.agentView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetAgentInstructionsResponse
 */
export const SetAgentInstructionsResponse = new SetAgentInstructionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAgentRequest$Type extends MessageType<DeleteAgentRequest> {
    constructor() {
        super("c1.api.user.v1.DeleteAgentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteAgentRequest>): DeleteAgentRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAgentRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAgentRequest): DeleteAgentRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAgentRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.DeleteAgentRequest
 */
export const DeleteAgentRequest = new DeleteAgentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAgentResponse$Type extends MessageType<DeleteAgentResponse> {
    constructor() {
        super("c1.api.user.v1.DeleteAgentResponse", []);
    }
    create(value?: PartialMessage<DeleteAgentResponse>): DeleteAgentResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAgentResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAgentResponse): DeleteAgentResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAgentResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.DeleteAgentResponse
 */
export const DeleteAgentResponse = new DeleteAgentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentRef$Type extends MessageType<AgentRef> {
    constructor() {
        super("c1.api.user.v1.AgentRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AgentRef>): AgentRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AgentRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentRef): AgentRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.AgentRef
 */
export const AgentRef = new AgentRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAgentsRequest$Type extends MessageType<SearchAgentsRequest> {
    constructor() {
        super("c1.api.user.v1.SearchAgentsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 10 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AgentRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAgentsRequest>): SearchAgentsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAgentsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAgentsRequest): SearchAgentsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.user.v1.AgentRef refs */ 3:
                    message.refs.push(AgentRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAgentsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.user.v1.AgentRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            AgentRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchAgentsRequest
 */
export const SearchAgentsRequest = new SearchAgentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAgentsResponse$Type extends MessageType<SearchAgentsResponse> {
    constructor() {
        super("c1.api.user.v1.SearchAgentsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AgentView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAgentsResponse>): SearchAgentsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAgentsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAgentsResponse): SearchAgentsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.AgentView list */ 1:
                    message.list.push(AgentView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAgentsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.AgentView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AgentView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchAgentsResponse
 */
export const SearchAgentsResponse = new SearchAgentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExpiringUserDelegationBindingRequest$Type extends MessageType<GetExpiringUserDelegationBindingRequest> {
    constructor() {
        super("c1.api.user.v1.GetExpiringUserDelegationBindingRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetExpiringUserDelegationBindingRequest>): GetExpiringUserDelegationBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<GetExpiringUserDelegationBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExpiringUserDelegationBindingRequest): GetExpiringUserDelegationBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExpiringUserDelegationBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetExpiringUserDelegationBindingRequest
 */
export const GetExpiringUserDelegationBindingRequest = new GetExpiringUserDelegationBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExpiringUserDelegationBindingResponse$Type extends MessageType<GetExpiringUserDelegationBindingResponse> {
    constructor() {
        super("c1.api.user.v1.GetExpiringUserDelegationBindingResponse", [
            { no: 1, name: "item", kind: "message", T: () => ExpiringUserDelegationBinding }
        ]);
    }
    create(value?: PartialMessage<GetExpiringUserDelegationBindingResponse>): GetExpiringUserDelegationBindingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExpiringUserDelegationBindingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExpiringUserDelegationBindingResponse): GetExpiringUserDelegationBindingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.ExpiringUserDelegationBinding item */ 1:
                    message.item = ExpiringUserDelegationBinding.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExpiringUserDelegationBindingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.ExpiringUserDelegationBinding item = 1; */
        if (message.item)
            ExpiringUserDelegationBinding.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetExpiringUserDelegationBindingResponse
 */
export const GetExpiringUserDelegationBindingResponse = new GetExpiringUserDelegationBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExpiringUserDelegationBindingByAdminRequest$Type extends MessageType<SetExpiringUserDelegationBindingByAdminRequest> {
    constructor() {
        super("c1.api.user.v1.SetExpiringUserDelegationBindingByAdminRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 3, name: "delegation_start_at", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } },
            { no: 4, name: "delegation_expire_at", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } }
        ]);
    }
    create(value?: PartialMessage<SetExpiringUserDelegationBindingByAdminRequest>): SetExpiringUserDelegationBindingByAdminRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.delegatedUserId = "";
        if (value !== undefined)
            reflectionMergePartial<SetExpiringUserDelegationBindingByAdminRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetExpiringUserDelegationBindingByAdminRequest): SetExpiringUserDelegationBindingByAdminRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string delegated_user_id */ 2:
                    message.delegatedUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp delegation_start_at */ 3:
                    message.delegationStartAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.delegationStartAt);
                    break;
                case /* google.protobuf.Timestamp delegation_expire_at */ 4:
                    message.delegationExpireAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.delegationExpireAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetExpiringUserDelegationBindingByAdminRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string delegated_user_id = 2; */
        if (message.delegatedUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.delegatedUserId);
        /* google.protobuf.Timestamp delegation_start_at = 3; */
        if (message.delegationStartAt)
            Timestamp.internalBinaryWrite(message.delegationStartAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp delegation_expire_at = 4; */
        if (message.delegationExpireAt)
            Timestamp.internalBinaryWrite(message.delegationExpireAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingByAdminRequest
 */
export const SetExpiringUserDelegationBindingByAdminRequest = new SetExpiringUserDelegationBindingByAdminRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExpiringUserDelegationBindingByAdminResponse$Type extends MessageType<SetExpiringUserDelegationBindingByAdminResponse> {
    constructor() {
        super("c1.api.user.v1.SetExpiringUserDelegationBindingByAdminResponse", [
            { no: 1, name: "item", kind: "message", T: () => ExpiringUserDelegationBinding }
        ]);
    }
    create(value?: PartialMessage<SetExpiringUserDelegationBindingByAdminResponse>): SetExpiringUserDelegationBindingByAdminResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetExpiringUserDelegationBindingByAdminResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetExpiringUserDelegationBindingByAdminResponse): SetExpiringUserDelegationBindingByAdminResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.ExpiringUserDelegationBinding item */ 1:
                    message.item = ExpiringUserDelegationBinding.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetExpiringUserDelegationBindingByAdminResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.ExpiringUserDelegationBinding item = 1; */
        if (message.item)
            ExpiringUserDelegationBinding.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingByAdminResponse
 */
export const SetExpiringUserDelegationBindingByAdminResponse = new SetExpiringUserDelegationBindingByAdminResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExpiringUserDelegationBindingSelfRequest$Type extends MessageType<SetExpiringUserDelegationBindingSelfRequest> {
    constructor() {
        super("c1.api.user.v1.SetExpiringUserDelegationBindingSelfRequest", [
            { no: 1, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "delegation_start_at", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } },
            { no: 3, name: "delegation_expire_at", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } }
        ]);
    }
    create(value?: PartialMessage<SetExpiringUserDelegationBindingSelfRequest>): SetExpiringUserDelegationBindingSelfRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.delegatedUserId = "";
        if (value !== undefined)
            reflectionMergePartial<SetExpiringUserDelegationBindingSelfRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetExpiringUserDelegationBindingSelfRequest): SetExpiringUserDelegationBindingSelfRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string delegated_user_id */ 1:
                    message.delegatedUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp delegation_start_at */ 2:
                    message.delegationStartAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.delegationStartAt);
                    break;
                case /* google.protobuf.Timestamp delegation_expire_at */ 3:
                    message.delegationExpireAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.delegationExpireAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetExpiringUserDelegationBindingSelfRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string delegated_user_id = 1; */
        if (message.delegatedUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.delegatedUserId);
        /* google.protobuf.Timestamp delegation_start_at = 2; */
        if (message.delegationStartAt)
            Timestamp.internalBinaryWrite(message.delegationStartAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp delegation_expire_at = 3; */
        if (message.delegationExpireAt)
            Timestamp.internalBinaryWrite(message.delegationExpireAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingSelfRequest
 */
export const SetExpiringUserDelegationBindingSelfRequest = new SetExpiringUserDelegationBindingSelfRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExpiringUserDelegationBindingSelfResponse$Type extends MessageType<SetExpiringUserDelegationBindingSelfResponse> {
    constructor() {
        super("c1.api.user.v1.SetExpiringUserDelegationBindingSelfResponse", [
            { no: 1, name: "item", kind: "message", T: () => ExpiringUserDelegationBinding }
        ]);
    }
    create(value?: PartialMessage<SetExpiringUserDelegationBindingSelfResponse>): SetExpiringUserDelegationBindingSelfResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetExpiringUserDelegationBindingSelfResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetExpiringUserDelegationBindingSelfResponse): SetExpiringUserDelegationBindingSelfResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.ExpiringUserDelegationBinding item */ 1:
                    message.item = ExpiringUserDelegationBinding.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetExpiringUserDelegationBindingSelfResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.ExpiringUserDelegationBinding item = 1; */
        if (message.item)
            ExpiringUserDelegationBinding.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingSelfResponse
 */
export const SetExpiringUserDelegationBindingSelfResponse = new SetExpiringUserDelegationBindingSelfResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserProfileTypesRequest$Type extends MessageType<GetUserProfileTypesRequest> {
    constructor() {
        super("c1.api.user.v1.GetUserProfileTypesRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetUserProfileTypesRequest>): GetUserProfileTypesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<GetUserProfileTypesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserProfileTypesRequest): GetUserProfileTypesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserProfileTypesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetUserProfileTypesRequest
 */
export const GetUserProfileTypesRequest = new GetUserProfileTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserProfileTypesResponse$Type extends MessageType<GetUserProfileTypesResponse> {
    constructor() {
        super("c1.api.user.v1.GetUserProfileTypesResponse", [
            { no: 1, name: "profile_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileType }
        ]);
    }
    create(value?: PartialMessage<GetUserProfileTypesResponse>): GetUserProfileTypesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profileTypes = [];
        if (value !== undefined)
            reflectionMergePartial<GetUserProfileTypesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserProfileTypesResponse): GetUserProfileTypesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.profiletype.v1.ProfileType profile_types */ 1:
                    message.profileTypes.push(ProfileType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserProfileTypesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.profiletype.v1.ProfileType profile_types = 1; */
        for (let i = 0; i < message.profileTypes.length; i++)
            ProfileType.internalBinaryWrite(message.profileTypes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetUserProfileTypesResponse
 */
export const GetUserProfileTypesResponse = new GetUserProfileTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreviewUserProfileWithProfileTypesRequest$Type extends MessageType<PreviewUserProfileWithProfileTypesRequest> {
    constructor() {
        super("c1.api.user.v1.PreviewUserProfileWithProfileTypesRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "profile_type_ids_to_add", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100" } } } },
            { no: 3, name: "profile_type_ids_to_remove", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<PreviewUserProfileWithProfileTypesRequest>): PreviewUserProfileWithProfileTypesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.profileTypeIdsToAdd = [];
        message.profileTypeIdsToRemove = [];
        if (value !== undefined)
            reflectionMergePartial<PreviewUserProfileWithProfileTypesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PreviewUserProfileWithProfileTypesRequest): PreviewUserProfileWithProfileTypesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* repeated string profile_type_ids_to_add */ 2:
                    message.profileTypeIdsToAdd.push(reader.string());
                    break;
                case /* repeated string profile_type_ids_to_remove */ 3:
                    message.profileTypeIdsToRemove.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PreviewUserProfileWithProfileTypesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* repeated string profile_type_ids_to_add = 2; */
        for (let i = 0; i < message.profileTypeIdsToAdd.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.profileTypeIdsToAdd[i]);
        /* repeated string profile_type_ids_to_remove = 3; */
        for (let i = 0; i < message.profileTypeIdsToRemove.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.profileTypeIdsToRemove[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.PreviewUserProfileWithProfileTypesRequest
 */
export const PreviewUserProfileWithProfileTypesRequest = new PreviewUserProfileWithProfileTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreviewUserProfileWithProfileTypesResponse$Type extends MessageType<PreviewUserProfileWithProfileTypesResponse> {
    constructor() {
        super("c1.api.user.v1.PreviewUserProfileWithProfileTypesResponse", [
            { no: 1, name: "current_profile", kind: "message", T: () => Struct },
            { no: 2, name: "projected_profile", kind: "message", T: () => Struct },
            { no: 3, name: "potentially_affected_references", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AffectedReference }
        ]);
    }
    create(value?: PartialMessage<PreviewUserProfileWithProfileTypesResponse>): PreviewUserProfileWithProfileTypesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.potentiallyAffectedReferences = [];
        if (value !== undefined)
            reflectionMergePartial<PreviewUserProfileWithProfileTypesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PreviewUserProfileWithProfileTypesResponse): PreviewUserProfileWithProfileTypesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Struct current_profile */ 1:
                    message.currentProfile = Struct.internalBinaryRead(reader, reader.uint32(), options, message.currentProfile);
                    break;
                case /* google.protobuf.Struct projected_profile */ 2:
                    message.projectedProfile = Struct.internalBinaryRead(reader, reader.uint32(), options, message.projectedProfile);
                    break;
                case /* repeated c1.api.user.v1.AffectedReference potentially_affected_references */ 3:
                    message.potentiallyAffectedReferences.push(AffectedReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PreviewUserProfileWithProfileTypesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Struct current_profile = 1; */
        if (message.currentProfile)
            Struct.internalBinaryWrite(message.currentProfile, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct projected_profile = 2; */
        if (message.projectedProfile)
            Struct.internalBinaryWrite(message.projectedProfile, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.AffectedReference potentially_affected_references = 3; */
        for (let i = 0; i < message.potentiallyAffectedReferences.length; i++)
            AffectedReference.internalBinaryWrite(message.potentiallyAffectedReferences[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.PreviewUserProfileWithProfileTypesResponse
 */
export const PreviewUserProfileWithProfileTypesResponse = new PreviewUserProfileWithProfileTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AffectedReference$Type extends MessageType<AffectedReference> {
    constructor() {
        super("c1.api.user.v1.AffectedReference", [
            { no: 1, name: "entity_type", kind: "enum", T: () => ["c1.api.user.v1.AffectedReferenceEntityType", AffectedReferenceEntityType, "AFFECTED_REFERENCE_ENTITY_TYPE_"] },
            { no: 2, name: "entity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entity_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cel_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "referenced_changing_fields", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AffectedReference>): AffectedReference {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entityType = 0;
        message.entityId = "";
        message.entityName = "";
        message.celExpression = "";
        message.referencedChangingFields = [];
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AffectedReference>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AffectedReference): AffectedReference {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.AffectedReferenceEntityType entity_type */ 1:
                    message.entityType = reader.int32();
                    break;
                case /* string entity_id */ 2:
                    message.entityId = reader.string();
                    break;
                case /* string entity_name */ 3:
                    message.entityName = reader.string();
                    break;
                case /* string cel_expression */ 4:
                    message.celExpression = reader.string();
                    break;
                case /* repeated string referenced_changing_fields */ 5:
                    message.referencedChangingFields.push(reader.string());
                    break;
                case /* string app_id */ 6:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AffectedReference, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.AffectedReferenceEntityType entity_type = 1; */
        if (message.entityType !== 0)
            writer.tag(1, WireType.Varint).int32(message.entityType);
        /* string entity_id = 2; */
        if (message.entityId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entityId);
        /* string entity_name = 3; */
        if (message.entityName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entityName);
        /* string cel_expression = 4; */
        if (message.celExpression !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.celExpression);
        /* repeated string referenced_changing_fields = 5; */
        for (let i = 0; i < message.referencedChangingFields.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.referencedChangingFields[i]);
        /* string app_id = 6; */
        if (message.appId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.AffectedReference
 */
export const AffectedReference = new AffectedReference$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserAvatarRequest$Type extends MessageType<SetUserAvatarRequest> {
    constructor() {
        super("c1.api.user.v1.SetUserAvatarRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "4", maxLen: "1000000" } } } }
        ]);
    }
    create(value?: PartialMessage<SetUserAvatarRequest>): SetUserAvatarRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<SetUserAvatarRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetUserAvatarRequest): SetUserAvatarRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* bytes data */ 2:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetUserAvatarRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* bytes data = 2; */
        if (message.data.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserAvatarRequest
 */
export const SetUserAvatarRequest = new SetUserAvatarRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserAvatarResponse$Type extends MessageType<SetUserAvatarResponse> {
    constructor() {
        super("c1.api.user.v1.SetUserAvatarResponse", []);
    }
    create(value?: PartialMessage<SetUserAvatarResponse>): SetUserAvatarResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetUserAvatarResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetUserAvatarResponse): SetUserAvatarResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetUserAvatarResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserAvatarResponse
 */
export const SetUserAvatarResponse = new SetUserAvatarResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserAvatarSelfRequest$Type extends MessageType<SetUserAvatarSelfRequest> {
    constructor() {
        super("c1.api.user.v1.SetUserAvatarSelfRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "4", maxLen: "1000000" } } } }
        ]);
    }
    create(value?: PartialMessage<SetUserAvatarSelfRequest>): SetUserAvatarSelfRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<SetUserAvatarSelfRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetUserAvatarSelfRequest): SetUserAvatarSelfRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes data */ 1:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetUserAvatarSelfRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes data = 1; */
        if (message.data.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserAvatarSelfRequest
 */
export const SetUserAvatarSelfRequest = new SetUserAvatarSelfRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserAvatarSelfResponse$Type extends MessageType<SetUserAvatarSelfResponse> {
    constructor() {
        super("c1.api.user.v1.SetUserAvatarSelfResponse", []);
    }
    create(value?: PartialMessage<SetUserAvatarSelfResponse>): SetUserAvatarSelfResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetUserAvatarSelfResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetUserAvatarSelfResponse): SetUserAvatarSelfResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetUserAvatarSelfResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserAvatarSelfResponse
 */
export const SetUserAvatarSelfResponse = new SetUserAvatarSelfResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.UserService
 */
export const UserService = new ServiceType("c1.api.user.v1.UserService", [
    { name: "Introspect", options: { "authz.method": { role: "REFLECTION" } }, I: IntrospectRequest, O: IntrospectResponse },
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/users/{id}", group: "User" }] }, "authz.method": { role: "VIEWER" } }, I: UserServiceGetRequest, O: UserServiceGetResponse },
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/users", query: { page_size: "page_size", page_token: "page_token" }, group: "User" }] }, "authz.method": { role: "VIEWER" } }, I: UserServiceListRequest, O: UserServiceListResponse },
    { name: "GetByIDs", options: { "authz.method": { role: "VIEWER" } }, I: UserServiceGetUsersByIDsRequest, O: UserServiceGetUsersByIDsResponse },
    { name: "Update", options: { "authz.method": { role: "OWNER" } }, I: UpdateUserRequest, O: UserServiceGetResponse },
    { name: "SetDelegatedUser", options: { "authz.method": { role: "EDITOR" } }, I: SetDelegatedUserRequest, O: UserServiceGetResponse },
    { name: "SetUserRoles", options: { "authz.method": { role: "EDITOR" } }, I: SetUserRolesRequest, O: UserServiceGetResponse },
    { name: "GetExpiringUserDelegationBinding", options: { "authz.method": { role: "VIEWER" } }, I: GetExpiringUserDelegationBindingRequest, O: GetExpiringUserDelegationBindingResponse },
    { name: "SetExpiringUserDelegationBindingByAdmin", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/users/{user_id}/set-delegation-by-admin", group: "User" }] }, "authz.method": { role: "OWNER" } }, I: SetExpiringUserDelegationBindingByAdminRequest, O: SetExpiringUserDelegationBindingByAdminResponse },
    { name: "SetExpiringUserDelegationBindingSelf", options: { "authz.method": { role: "EDITOR" } }, I: SetExpiringUserDelegationBindingSelfRequest, O: SetExpiringUserDelegationBindingSelfResponse },
    { name: "GetUserProfileTypes", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/users/{user_id}/profile-types", group: "User" }] }, "authz.method": { role: "VIEWER" } }, I: GetUserProfileTypesRequest, O: GetUserProfileTypesResponse },
    { name: "PreviewUserProfileWithProfileTypes", options: { "authz.method": { role: "VIEWER" } }, I: PreviewUserProfileWithProfileTypesRequest, O: PreviewUserProfileWithProfileTypesResponse },
    { name: "SetUserAvatar", options: { "authz.method": { role: "OWNER" } }, I: SetUserAvatarRequest, O: SetUserAvatarResponse },
    { name: "SetUserAvatarSelf", options: { "authz.method": { role: "EDITOR" } }, I: SetUserAvatarSelfRequest, O: SetUserAvatarSelfResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.UserSearch
 */
export const UserSearch = new ServiceType("c1.api.user.v1.UserSearch", [
    { name: "Search", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/users", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "User", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Users", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "User", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] }, "authz.method": { role: "VIEWER" } }, I: SearchUsersRequest, O: SearchUsersResponse },
    { name: "SearchManagedUsers", options: { "authz.method": { role: "VIEWER" } }, I: SearchManagedUsersRequest, O: SearchManagedUsersResponse },
    { name: "SearchManagedUsersForAccessRequests", options: { "authz.method": { role: "VIEWER" } }, I: SearchManagedUsersForAccessRequestsRequest, O: SearchManagedUsersForAccessRequestsResponse },
    { name: "CountAppUsersWithoutManager", options: { "authz.method": { role: "VIEWER" } }, I: CountAppUsersWithoutManagerRequest, O: CountAppUsersWithoutManagerResponse },
    { name: "UsersWithoutManager", options: { "authz.method": { role: "VIEWER" } }, I: UsersWithoutManagerRequest, O: UsersWithoutManagerResponse },
    { name: "SearchUsersWithUnspecifiedEmploymentStatus", options: { "authz.method": { role: "VIEWER" } }, I: UsersWithUnspecifiedEmploymentStatusRequest, O: UsersWithUnspecifiedEmploymentStatusResponse },
    { name: "SearchWithCEL", options: { "authz.method": { role: "VIEWER" } }, I: SearchUsersWithCELRequest, O: SearchUsersWithCELResponse },
    { name: "StreamSearchWithCEL", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: StreamSearchUsersWithCELRequest, O: StreamSearchUsersWithCELResponse },
    { name: "SearchUserAttributesWithProfileTypeSource", options: { "authz.method": { role: "VIEWER" } }, I: SearchUserAttributesWithProfileTypeSourceRequest, O: SearchUserAttributesWithProfileTypeSourceResponse },
    { name: "GetEmploymentStatusSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetEmploymentStatusSearchTermsRequest, O: GetEmploymentStatusSearchTermsResponse },
    { name: "GetJobTitleSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetJobTitleSearchTermsRequest, O: GetJobTitleSearchTermsResponse },
    { name: "GetDepartmentSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetDepartmentSearchTermsRequest, O: GetDepartmentSearchTermsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.AgentService
 */
export const AgentService = new ServiceType("c1.api.user.v1.AgentService", [
    { name: "CreateAgent", options: { "authz.method": { role: "OWNER" } }, I: CreateAgentRequest, O: CreateAgentResponse },
    { name: "GetAgent", options: { "authz.method": { role: "OWNER" } }, I: GetAgentRequest, O: GetAgentResponse },
    { name: "SetAgentInstructions", options: { "authz.method": { role: "OWNER" } }, I: SetAgentInstructionsRequest, O: SetAgentInstructionsResponse },
    { name: "DeleteAgent", options: { "authz.method": { role: "OWNER" } }, I: DeleteAgentRequest, O: DeleteAgentResponse },
    { name: "ListAgents", options: { "authz.method": { role: "OWNER" } }, I: ListAgentsRequest, O: ListAgentsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.AgentSearchService
 */
export const AgentSearchService = new ServiceType("c1.api.user.v1.AgentSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAgentsRequest, O: SearchAgentsResponse }
]);
